<div attr.aria-label="Coupon - {{coupon.newOfferPrice}} - {{coupon.refineBrand}}" class="grid-coupon-container"
     role="region">
    <div class="grid-coupon-wrapper">
        <div class="grid-coupon-heading">
            <div class="grid-coupon-heading-text-wrapper">
                <span class="grid-coupon-heading-text">
                    <img alt="Just 4 U Freshpass logo" aria-label="Just 4 U Freshpass logo"
                         class="svg-icon just-for-you-16px icon-position" src="ocsp-web-ui/dist/assets/images/freshpass-logo.svg">
                    <span class="grid-coupon-heading-offer-price" id="coupon-price-{{coupon.offerId}}"
                          tabindex="-1">{{coupon.newOfferPrice}}</span>
                </span>
                <span *ngIf="isWWW" class="grid-coupon-heading-text">
                    <span [ngClass]="{'in-store-price-visible' : coupon.regularPrice && coupon.regularPrice != ''}" class="grid-coupon-heading-offer-price in-store-price"
                          id="coupon-price-{{coupon.offerId}}">{{properties.confirmation.IN_STORE}}: ${{coupon.regularPrice}}</span>
                </span>
            </div>
        </div>
        <div class="grid-coupon-item-description">
            <div class="grid-coupon-text">
                <div class="grid-coupon-description-text">
                    <span class="grid-coupon-description-text-title" id="coupon-title-{{coupon.offerId}}">
                        {{coupon.refineBrand}}
                    </span>
                </div>
                <div class="grid-coupon-description-text-details-wrapper">
                    <div>
                        <div class="grid-coupon-description-text-details">
                            <div id="coupon-description-{{coupon.offerId}}">
                                {{coupon.refineDescription}}
                            </div>
                            <span>
                                <a [attr.aria-describedby]="'coupon-price-' + coupon.offerId + ' ' + 'coupon-title-' + coupon.offerId + ' ' + 'coupon-description-' + coupon.offerId"
                                   class="grid-coupon-details-link"
                                   href="{{domain}}{{couponDetailPath}}.{{coupon.couponID}}.{{coupon.offerTs}}.{{coupon.offerPgm}}.html">
                                   <span>{{properties.confirmation.OFFER_DETAILS}}</span>
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-coupon-description-image-wrapper">
                <span class="grid-coupon-description-image">
                    <picture>
                        <source media="(min-width: {{md}})" srcset="{{getImageUrl('desktop')}}">
                        <source media="(min-width: {{sm}})" srcset="{{getImageUrl('tablet')}}">
                        <img [alt]="coupon.refineBrand" class="ab-lazy" loading="lazy" role="presentation"
                             src="{{getImageUrl('mobile')}}"/>
                    </picture>
                </span>
            </div>
        </div>
        <div aria-live="polite" class="grid-coupon-details">
            <div class="grid-coupon-exp-date">
                <span class="grid-coupon-details-expiration">{{ coupon.usageTypeTxt }}</span>
                <span class="grid-coupon-details-expiration-date">Expires {{dateConversion(coupon.endDate)}}</span>
            </div>
            <div class="grid-coupon-clip-button-wrapper">
                <div [ngClass]="{'grid-coupon-clip-button' : true, 'clipped': coupon.status == 'C' }"
                     id="clippedCouponGrid{{coupon.couponID}}">
                    <ng-container *ngIf="coupon.status == 'U'">
                        <button (click)="clipCoupon()"
                                (keydown.enter)="clipCoupon()" [attr.aria-describedby]="'coupon-price-' + coupon.offerId + ' ' + 'coupon-title-' + coupon.offerId + ' ' + 'coupon-description-' + coupon.offerId" [disabled]="showLoadingCoupon"
                                [ngClass]="{'btn':true, 'grid-coupon-btn':true, 'btn-default':true , 'loading-coupon-item': showLoadingCoupon}" id="couponAddBtn{{coupon.couponID}}"
                                role="button">{{clipCouponLabel}}</button>
                    </ng-container>
                    <ng-container *ngIf="coupon.status == 'C'">
                        <span [attr.aria-describedby]="'coupon-price-' + coupon.offerId + ' ' + 'coupon-title-' + coupon.offerId + ' ' + 'coupon-description-' + coupon.offerId"
                              class="coupon-clipped-container">
                            <svg aria-hidden="true" class="svg-icon svg-icon-coupon-carousel-tick-mark" height="18px"
                                 version="1.1" viewBox="0 0 24 24" width="18px" xmlns="http://www.w3.org/2000/svg"
                                 xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g fill-rule="evenodd" id="Symbols" stroke-width="1">
                                    <g fill="#757575" id="Icons-/-Universal-/-Check-/-Gray">
                                        <polygon id="GreenCheck"
                                                 points="19.6926976 5 21.1720549 6.34592056 9.50596091 19.1686094 3 12.9800394 4.37842439 11.5309203 9.40273692 16.3101236"></polygon>
                                    </g>
                                </g>
                            </svg>
                            {{clippedLabel}}
                        </span>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
